import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api'
import { ConsentApplication } from '../../models/polymer/ConsentApplication.model'
import config from '../../config'
import { PolymerCrypto } from '../../utils/encryptor'
interface QueryParams {
  application_id: string
  uinfin: string,
  singpass_token: string
}

interface CheckApplicantHasConsentAPI {
  consent_given: boolean,
  consent_application: ConsentApplication,
}

export const checkApplicantHasConsentApi = createApi({
  reducerPath: 'checkApplicantHasConsentApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER,
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "POST");
    headers.set("X-Content-Type-Options", "nosniff");
    headers.set("x-api-key", `${config.xApiKey}`);
  }}),
  endpoints: (builder) => ({
    getCheckApplicantHasConsentStatus: builder.query<CheckApplicantHasConsentAPI, QueryParams>({
      query: (queryParams: QueryParams) => (
        {
        method: "GET",
        url:`${SUB_PATH_BASIC}/checkApplicationConsent?applicationUuid=${queryParams.application_id}`,
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      transformResponse:(response: ConsentApplication, meta, arg)=>{
        const consent_given = response.owners_consent_status.find(e=> PolymerCrypto.decryption(e.uin_fin) === arg.uinfin)?.consent_given ?? false;
        return {
          consent_given:consent_given,
          consent_application: response
        };
      },
      keepUnusedDataFor:1,
    }),
   
  }),
})

export const { useGetCheckApplicantHasConsentStatusQuery } = checkApplicantHasConsentApi

